import { createAsyncThunk } from '@reduxjs/toolkit';
import { getToken } from '../../Utils/authUtils';
import { _expressUrls } from '../../constant';

export interface SaveClipSettingPayload {
  studyUID: string;
  sopInstanceUID: string;
  playbackRate: number;
}

/** Persist one clip's playback rate so the next reader opens it at the same speed. */
export const saveClipSetting = createAsyncThunk(
  'express/saveClipSetting',
  async (payload: SaveClipSettingPayload, { rejectWithValue }) => {
    try {
      const token = getToken();
      if (!token) {
        return rejectWithValue('No token found');
      }

      const response = await fetch(_expressUrls.SAVE_CLIP_SETTING, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        return rejectWithValue(errorData.msg || `HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
